import MigrationWarning from "../../../../contents/docs/migrate/_snippets/migration-warning.mdx";
import SDKMigration from "../../../../contents/docs/migrate/_snippets/sdk-migration.mdx";
import ApiMigration from "../../../../contents/docs/migrate/_snippets/api-migration.mdx";
import * as React from 'react';
export default {
  MigrationWarning,
  SDKMigration,
  ApiMigration,
  React
};